import { addLinkEventUTMSource, formatBannerEventDate } from "src/functions/dateFormats"
import "./styles.less"
import { useContext } from "react"
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context"

export const EventBanner = ({ link, logo, date }: { link: string, logo: string, date: string }) => {
    const { translations } = useContext(ConfigStateContext)
    return (
        <div className="container-banner-event">
            <a href={addLinkEventUTMSource(link)} className="banner-event" id="banner-event" target="_blank">
                <div className="logo-container">
                    <span>Este proyecto lo {translations.puedes} conocer en</span>
                    <img id="img-event" src={logo} className="logo" />
                </div>

                <div className="right-side">
                    <div className="date">
                        <img src="https://cdn4.fincaraiz.com.co/web/655cdc70860e7_preheader-calendario.png" />
                        <span className="banner-date" id="banner-date">
                            {formatBannerEventDate(date)}
                        </span>
                    </div>
                    <img src="https://cdn4.fincaraiz.com.co/web/655cdc6c69e65_preheader-cta.png" className="cta" />
                </div>
            </a>
        </div>
    )
}